export default "__VITE_ASSET__D0OMa5iM__"